import styled from 'styled-components';

export const Container = styled.section`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 0.6rem;
  padding: 1rem;
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  background: var(--stone-50);
  text-align: center;

  svg {
    color: var(--primary-hover);
    width: 32px;
    height: 32px;
  }
`;

export const Text = styled.p`
  font-size: 0.85rem;
  line-height: 1.4;
  text-align: center;
  color: var(--stone-600);
  height: auto;
`;
